import ProductBadge from './ProductBadge';

export default ProductBadge;
